var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M10 17l5-5-5-5v10z"}}),_c('path',{attrs:{"fill":"none","d":"M0 24V0h24v24H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }